import { FC } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

interface PreserveJobOrderIdNavigateProps {
  to: string;
}

export const PreserveJobOrderIdNavigate: FC<PreserveJobOrderIdNavigateProps> = ({ to }) => {
  const location = useLocation();
  const params = useParams();

  const searchParams = new URLSearchParams(location.search);

  if (params.jobOrderId && !searchParams.has('jobOrderId')) {
    searchParams.set('jobOrderId', params.jobOrderId);
  }

  return (
    <Navigate
      to={{
        pathname: to,
        search: searchParams.toString(),
      }}
      replace
    />
  );
};
